// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const LPCO_ST = {
  EmDigitacao: 'LPCO_ST1',
  ParaAnalise: 'LPCO_ST2',
  Deferido: 'LPCO_ST3',
  Indeferido: 'LPCO_ST4',
  Vencido: 'LPCO_ST5',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    LPCO_ST1: 1,
    LPCO_ST2: 2,
    LPCO_ST3: 3,
    LPCO_ST4: 4,
    LPCO_ST5: 5
  }
}
